var moduleMap = {
	"./ClassicForm": () => {
		return Promise.all(/* __federation_expose_ClassicForm */[__webpack_require__.e(941), __webpack_require__.e(890), __webpack_require__.e(332), __webpack_require__.e(807), __webpack_require__.e(505), __webpack_require__.e(642)]).then(() => (() => ((__webpack_require__(1838)))));
	},
	"./SliderForm": () => {
		return Promise.all(/* __federation_expose_SliderForm */[__webpack_require__.e(941), __webpack_require__.e(890), __webpack_require__.e(332), __webpack_require__.e(505), __webpack_require__.e(461)]).then(() => (() => ((__webpack_require__(9497)))));
	}
};
var get = (module, getScope) => {
	__webpack_require__.R = getScope;
	getScope = (
		__webpack_require__.o(moduleMap, module)
			? moduleMap[module]()
			: Promise.resolve().then(() => {
				throw new Error('Module "' + module + '" does not exist in container.');
			})
	);
	__webpack_require__.R = undefined;
	return getScope;
};
var init = (shareScope, initScope, remoteEntryInitOptions) => {
	return __webpack_require__.federation.bundlerRuntime.initContainerEntry({	webpackRequire: __webpack_require__,
		shareScope: shareScope,
		initScope: initScope,
		remoteEntryInitOptions: remoteEntryInitOptions,
		shareScopeKey: "default"
	})
};


// This exports getters to disallow modifications
__webpack_require__.d(exports, {
	get: () => (get),
	init: () => (init)
});